/**
 * Defines extra chance/second chance games that have a unique ticket input template
 */
const EXTRACHANCE_GAMES_LIST = [
    {
        id: 0,
        name: "default",
        inputsToCreate: [
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            },
            {
                maxLength: 1,
                cssClasses: "numeric-only input-length-1",
                regexPattern: "\d*"
            },
            {
                maxLength: 3,
                cssClasses: "numeric-only input-length-3",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "eXTRA Chances Code",
            maxLength: 6,
            cssClasses: "input-length-6",
            regexPattern: "\d*"
        }
    },
    {
        id: 1841,
        name: "Extreme Millions",
        inputsToCreate: [
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            },
            {
                maxLength: 1,
                cssClasses: "numeric-only input-length-1",
                regexPattern: "\d*"
            },
            {
                maxLength: 3,
                cssClasses: "numeric-only input-length-3",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "Web Code",
            maxLength: 6,
            cssClasses: "input-length-6",
            regexPattern: "\d*"
        }
    },
	{
        id: 1932,
        name: "Ultimate Vegas Get Away",
        inputsToCreate: [
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            },
            {
                maxLength: 3,
                cssClasses: "numeric-only input-length-3",
                regexPattern: "\d*"
            },
            {
                maxLength: 1,
                cssClasses: "numeric-only input-length-1",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "Web Code",
            maxLength: 6,
            cssClasses: "input-length-6",
            regexPattern: "\d*"
        }
    },
	{
        id: 156,
        name: "GasNGo",
        inputsToCreate: [
            {
                maxLength: 4,
                cssClasses: "numeric-only input-length-4",
                regexPattern: "\d*"
            },
			{
                maxLength: 9,
                cssClasses: "numeric-only input-length-9",
                regexPattern: "\d*"
            },
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "Gas N Go Number",
            maxLength: 7,
            cssClasses: "input-length-7",
            regexPattern: "\d*"
        }
    },
	{
        id: 149,
        name: "MegaGrocery",
        inputsToCreate: [
            {
                maxLength: 4,
                cssClasses: "numeric-only input-length-4",
                regexPattern: "\d*"
            },
			{
                maxLength: 9,
                cssClasses: "numeric-only input-length-9",
                regexPattern: "\d*"
            },
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "Mega Grocery Number",
            maxLength: 7,
            cssClasses: "input-length-7",
            regexPattern: "\d*"
        }
    },
	{
        id: 152,
        name: "NyRockingEve",
        inputsToCreate: [
            {
                maxLength: 4,
                cssClasses: "numeric-only input-length-4",
                regexPattern: "\d*"
            },
			{
                maxLength: 9,
                cssClasses: "numeric-only input-length-9",
                regexPattern: "\d*"
            },
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "Powerball NYRE Promotion Number",
            maxLength: 7,
            cssClasses: "input-length-7",
            regexPattern: "\d*"
        }
    },
	{
        id: 153,
        name: "FanCave",
        inputsToCreate: [
            {
                maxLength: 4,
                cssClasses: "numeric-only input-length-4",
                regexPattern: "\d*"
            },
			{
                maxLength: 9,
                cssClasses: "numeric-only input-length-9",
                regexPattern: "\d*"
            },
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "Ultimate FanCave Promotion Number",
            maxLength: 7,
            cssClasses: "input-length-7",
            regexPattern: "\d*"
        }
    },
    {
        id: 88888,
        name: "Daily Cash",
        inputsToCreate: [
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            },
            {
                maxLength: 1,
                cssClasses: "numeric-only input-length-1",
                regexPattern: "\d*"
            },
            {
                maxLength: 3,
                cssClasses: "numeric-only input-length-3",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "Raffle Number",
            maxLength: 6,
            cssClasses: "numeric-only input-length-6",
            regexPattern: "\d*"
        }
    },
	{
        id: 2036,
        name: "CrossWord",
        inputsToCreate: [
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            },
            {
                maxLength: 3,
                cssClasses: "numeric-only input-length-3",
                regexPattern: "\d*"
            },
            {
                maxLength: 1,
                cssClasses: "numeric-only input-length-1",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "Web Code",
            maxLength: 6,
            cssClasses: "input-length-6",
            regexPattern: "\d*"
        }
    },
	{
        id: 1952,
        name: "Luxury Cruisin",
        inputsToCreate: [
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            },
            {
                maxLength: 3,
                cssClasses: "numeric-only input-length-3",
                regexPattern: "\d*"
            },
            {
                maxLength: 1,
                cssClasses: "numeric-only input-length-1",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "Web Code",
            maxLength: 6,
            cssClasses: "input-length-6",
            regexPattern: "\d*"
        }
    },
    {
        id: 99999,
        name: "Cashword Crossword",
        inputsToCreate: [
            {
                maxLength: 6,
                cssClasses: "numeric-only input-length-6",
                regexPattern: "\d*"
            },
            {
                maxLength: 1,
                cssClasses: "numeric-only input-length-1",
                regexPattern: "\d*"
            },
            {
                maxLength: 3,
                cssClasses: "numeric-only input-length-3",
                regexPattern: "\d*"
            }
        ],
        webCode: {
            hasWebCode: true,
            labelText: "Web Code",
            maxLength: 6,
            cssClasses: "numeric-only input-length-6",
            regexPattern: "\d*"
        }
    }
];

export default EXTRACHANCE_GAMES_LIST;


// WEBPACK FOOTER //
// ./features/extrachances/EXTRACHANCE_GAMES_LIST.js